export function resetSuccess() {
  return {
    type: 'SUCCESS',
    error: null
  };
}
